var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _GuidLegacy_value, _a, _Guid_value, _Guid_empty;
import { valueOf } from "../types";
import { isNullOrEmpty } from "./isNullOrEmpty";
const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};
export class GuidLegacy {
    constructor(value) {
        _GuidLegacy_value.set(this, void 0);
        __classPrivateFieldSet(this, _GuidLegacy_value, value, "f");
    }
    static IsEmpty(value) {
        return isNullOrEmpty(value) || value === GuidLegacy.Empty;
    }
    static IsNotEmpty(value) {
        return GuidLegacy.IsValid(value) && !GuidLegacy.IsEmpty(value);
    }
    static NewGuid() {
        let id = uuidv4();
        return id;
    }
    static IsValid(value) {
        if (isNullOrEmpty(value)) {
            return false;
        }
        const pattern = new RegExp('^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$', 'i');
        return pattern.test(value);
    }
    static get PrimaryKey() {
        return `FFFFFFFF-FFFF-FFFF-FFFF-FFFFFFFFFFFF`;
    }
    static get Empty() {
        return '00000000-0000-0000-0000-000000000000';
    }
    toString() {
        return __classPrivateFieldGet(this, _GuidLegacy_value, "f");
    }
}
_GuidLegacy_value = new WeakMap();
export class Guid {
    constructor(value) {
        _Guid_value.set(this, void 0);
        if (!Guid.isValid(value))
            throw new Error('Invalid Guid');
        __classPrivateFieldSet(this, _Guid_value, value, "f");
    }
    static get empty() {
        if (__classPrivateFieldGet(this, _a, "f", _Guid_empty) == null)
            __classPrivateFieldSet(this, _a, new Guid('00000000-0000-0000-0000-000000000000'), "f", _Guid_empty);
        return __classPrivateFieldGet(this, _a, "f", _Guid_empty);
    }
    static newGuid() {
        const guid = uuidv4();
        return new Guid(guid);
    }
    equals(value) {
        if (value instanceof Guid)
            return __classPrivateFieldGet(this, _Guid_value, "f") == value.toString();
        if (typeof value === 'string')
            return __classPrivateFieldGet(this, _Guid_value, "f") == value;
        return false;
    }
    isEmpty() {
        return __classPrivateFieldGet(this, _Guid_value, "f") == Guid.empty.toString();
    }
    toString() {
        return __classPrivateFieldGet(this, _Guid_value, "f");
    }
    static parse(value) {
        return new Guid(value);
    }
    static tryParse(value, output) {
        try {
            const guid = new Guid(value);
            output === null || output === void 0 ? void 0 : output.setValue(guid);
            return true;
        }
        catch (error) {
            output === null || output === void 0 ? void 0 : output.setValue(Guid.empty);
            return false;
        }
    }
    static isValid(value) {
        if (value instanceof Guid)
            return true;
        const pattern = new RegExp('^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$', 'i');
        return pattern.test(value);
    }
}
_a = Guid, _Guid_value = new WeakMap();
_Guid_empty = { value: null };
const value = valueOf();
Guid.tryParse('00000000-0000-0000-0000-000000000000', value);
